import { Component, ChangeDetectionStrategy, ViewChild, ElementRef } from '@angular/core';
import { Column, BeanStub, Utils as _ } from 'ag-grid-community';
import { IHeaderAngularComp } from 'ag-grid-angular/main';
import { IHeaderParams } from 'ag-grid-community/main';

@Component({
    selector: 'heade-tooltip',
    template: require('./header-tooltip-ag-renderer.component.html'),
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class HeaderTooltipAgRendererComponent extends BeanStub implements IHeaderAngularComp {

    public displayName: string;

    @ViewChild('eSortAsc')
    private eSortAsc: ElementRef;

    @ViewChild('eSortDesc')
    private eSortDesc: ElementRef;

    @ViewChild('eLabel')
    private eLabel: ElementRef;

    @ViewChild('eText')
    private eText: ElementRef;

    private params: IHeaderParams;

    public agInit(params: IHeaderParams): void {
        this.displayName = params.displayName;
        this.params = params;
        this.setupSort();
    }

    public setupSort(): void {
        let enableSorting = this.params.enableSorting;

        if (!enableSorting) {
            this.removeSorters();
            return;
        }

        if (this.eLabel) {
            this.eLabel.nativeElement.addEventListener('click', (event: MouseEvent) => {
                this.params.progressSort(event.shiftKey);
            });
        }

        this.addDestroyableEventListener(this.params.column, Column.EVENT_SORT_CHANGED, this.onSortChanged.bind(this));
        this.onSortChanged();
    }

    private onSortChanged(): void {
        _.addOrRemoveCssClass(this.eLabel.nativeElement, 'ag-header-cell-sorted-asc', this.params.column.isSortAscending());
        _.addOrRemoveCssClass(this.eLabel.nativeElement, 'ag-header-cell-sorted-desc', this.params.column.isSortDescending());
        _.addOrRemoveCssClass(this.eLabel.nativeElement, 'ag-header-cell-sorted-none', this.params.column.isSortNone());

        if (this.eSortAsc) {
            _.addOrRemoveCssClass(this.eSortAsc.nativeElement, 'ag-hidden', !this.params.column.isSortAscending());
        }

        if (this.eSortDesc) {
            _.addOrRemoveCssClass(this.eSortDesc.nativeElement, 'ag-hidden', !this.params.column.isSortDescending());
        }
    }

    private removeSorters() {
        const sorters = [this.eSortAsc.nativeElement, this.eSortDesc.nativeElement];
        sorters.forEach((el) => el.parentNode.removeChild(el));
    }
}